export function isOlderThan13(personalIdNumber: string): boolean {
  const latestAllowedBirthday = new Date();
  latestAllowedBirthday.setFullYear(latestAllowedBirthday.getFullYear() - 13);
  latestAllowedBirthday.setHours(0, 0, 0, 0);
  const birthYear = +personalIdNumber.substring(0, 4);
  const birthMonth = +personalIdNumber.substring(4, 6) - 1;
  const encodedDay = +personalIdNumber.substring(6, 8);
  const birthDay = encodedDay >= 61 && encodedDay <= 91 ? encodedDay - 60 : encodedDay;
  return new Date(birthYear, birthMonth, birthDay).getTime() <= latestAllowedBirthday.getTime();
}
